// Local-only play statistics: games played, moves made, draws, games
// won. localStorage on this browser, never sent anywhere, and allowed
// to be inaccurate — every operation is best-effort and failure-silent.
const KEY = "sat-stats-v1";

export function readStats() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY)) ?? {};
    return {
      games: raw.games | 0,
      moves: raw.moves | 0,
      draws: raw.draws | 0,
      wins: raw.wins | 0,
    };
  } catch {
    return { games: 0, moves: 0, draws: 0, wins: 0 };
  }
}

// Dragging stats.txt to the Recycle Bin "deletes" the note — the
// ledger zeroes and a fresh file takes its place.
export function clearStats() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Stats are decorative by decree.
  }
}

export function bumpStat(key, n = 1) {
  try {
    const s = readStats();
    s[key] = (s[key] | 0) + n;
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    // Stats are decorative by decree.
  }
}
